export const ACTIVE = 'Active'
export const ADMINISTRATOR = 'Administrator'
export const LEADER_TEAM = 'Leader Team'
export const PENDING = 'Pending'
export const TEACHER = 'Teacher'
export const USER_COUNT_HEADER_TEXT = 'Users'
